// TODO: Is there a better name/location for this file?

// Class that should be applied to all tour elements
export const PN_TOUR_CLASS = "pn-tour";
export const DISABLE_POINTER_EVENTS_CLASS = "pn-disable-pointer-events";

// Key for local storage to keep track of the currently selected project
export const STORAGE_CURRENT_PROJECT_UUID = "current_project_uuid";

// Temporary highlights rendered on the page when the selection is lost
export const TEMP_HIGHLIGHT_UUID = "js-aa-tmp-annotation";
